const modeloFormularioEnumerators = {
  clasificacion: [
    'operativa',
    'mantenimiento',
    'incidente',
    'investigacionIncidente',
    'inspeccion',
    'observacion',
  ],
};

export default modeloFormularioEnumerators;
